import { Popover } from 'primeng/popover';

export interface EllipsisListboxEvent {
  option?: { value?: string };
  value?: string;
}

export function getEllipsisOptionValue(event: EllipsisListboxEvent): string | undefined {
  return event?.option?.value ?? event?.value;
}

export function toggleEllipsisPopover(event: MouseEvent, popover: Popover): void {
  event.preventDefault();
  event.stopPropagation();

  const target = event.currentTarget as HTMLElement;

  if (popover.overlayVisible) {
    if (popover.target === target) {
      popover.hide();
      return;
    }

    popover.target = target;
    popover.align();
    return;
  }

  popover.show(event, target);
}
